export type SupportCenterCancelReasonKind = 'triagem' | 'atendimento'

export const SUPPORT_CENTER_CANCEL_REASON_KIND_LABELS: Record<
  SupportCenterCancelReasonKind,
  string
> = {
  triagem: 'Triagem',
  atendimento: 'Atendimento',
}

export interface SupportCenterCancelReason {
  id: string
  name: string
  description: string
  kind: SupportCenterCancelReasonKind
  created_at: string
  updated_at: string
  deleted_at: string | null
  deleted_by: string | null
  deleted_reason: string | null
}

export type SupportCenterCancelReasonInput = {
  id?: string
  name: string
  description: string
  kind: SupportCenterCancelReasonKind
}
